import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  capturedEvent: null,
  error: null,
  loading: false,
  success: false,
};

const captureEventStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

export const captureEventFinish = (state, action) => {
  return updateObject(state, { error: null, loading: true, success: false });
};

const captureEventSuccess = (state, action) => {
  return updateObject(state, {
    capturedEvent: action.capturedEvent,
    error: null,
    loading: false,
    success: true,
  });
};

const captureEventFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    success: true,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CAPTURE_START:
      return captureEventStart(state, action);
    case actionTypes.CAPTURE_SUCCESS:
      return captureEventSuccess(state, action);
    case actionTypes.CAPTURE_FAIL:
      return captureEventFail(state, action);
    case actionTypes.CAPTURE_FINISH:
      return captureEventFinish(state, action);
    default:
      return state;
  }
};

export default reducer;
